const state = {
  /**
   * @var int Total count of tasks being edited
   */
  editing: 0
}

const mutations = {
  incrementEditingCount (state) {
    state.editing++
  },
  decrementEditingCount (state) {
    state.editing = Math.max(state.editing - 1, 0)
  },
  resetEditingCount (state) {
    state.editing = 0
  }
}

const getters = {
  editingCount (state) {
    return state.editing
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}